export const META_TYPE = 'analysis';
export const META_VER = 'v1';

export const CMD_ANALYSIS_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
